import React from 'react';
import { Flex, Box, Text } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

import TeamMemberCard from '../../components/TeamMemberCard/TeamMemberCard';
import Button from '../../components/Button/Button';
import Markup from '../../base/Markup/Markup';
import WideContainer from '../../components/WideContainer/WideContainer';
import ThinContainer from '../../components/ThinContainer/ThinContainer';
import Typography, {
  TypographyContextProvider,
} from '../../components/Typography/Typography';

import colourMatching from '../../utils/colourMatching';
import createMemo from '../../utils/storyblokRelationsMemo';
import isFadeEnabled from '../../utils/isFadeEnabled';
import { TeamMemberSummarySectionStoryblok } from '../../types/storyblok';
import { Type } from '../../base/Type/Type';

const itemsMemo = createMemo([]);

const TeamMemberSummarySection = ({
  title,
  richText,
  items: itemsRel,
  buttonText,
  buttonUrl,
  colourScheme,
}: TeamMemberSummarySectionStoryblok) => {
  const items = itemsMemo(itemsRel);

  return (
    <TypographyContextProvider value={{ colourScheme }}>
      <Box
        as="section"
        backgroundColor={colourMatching(colourScheme)}
        px={[3, 4]}
        py={[8, 9, 10]}
      >
        <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
          <Scene classToggle="full-opacity">
            <WideContainer className={isFadeEnabled() ? 'zero-opacity' : ''}>
              <Flex flexWrap="wrap">
                {title && (
                  <Box width={1} pb={[3, 5, 8]}>
                    <Type as="h2" className="mx-auto text-center font-helvetica text-[36px]">
                      {title}
                    </Type>
                  </Box>
                )}

                {richText && (
                  <ThinContainer width={1} textAlign="center" px={4} pb={9}>
                    <Markup content={richText} />
                  </ThinContainer>
                )}

                <Box width={1}>
                  <Flex width={1} flexWrap="wrap" justifyContent="center">
                    {items.length > 0 ? (
                      items.map((item) => {
                        return (
                          <Box
                            key={item.uuid}
                            s
                            width={[1 / 2, 1 / 3, 1 / 6]}
                            px={3}
                            pb={[4, , 8]}
                          >
                            <TeamMemberCard
                              image={item.content?.photo}
                              name={item.content?.fullName}
                              description={item.content?.jobTitle}
                              link={item.content?.linkedinId}
                              colourScheme={colourScheme}
                            />
                          </Box>
                        );
                      })
                    ) : (
                      <Typography textAlign="center" width={1}>
                        No items added
                      </Typography>
                    )}
                  </Flex>
                </Box>

                {buttonText && (
                  <Box
                    width={1}
                    alignSelf="flex-end"
                    textAlign="center"
                    pt={[3, 5, 8]}
                  >
                    <Button
                      href={buttonUrl}
                      justifySelf="center"
                      arrow
                      colourScheme={colourScheme}
                    >
                      {buttonText}
                    </Button>
                  </Box>
                )}
              </Flex>
            </WideContainer>
          </Scene>
        </Controller>
      </Box>
    </TypographyContextProvider>
  );
};

export default TeamMemberSummarySection;
